import { ModuleWithProviders, NgModule } from '@angular/core';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { DxDropDownBoxModule, DxTextBoxModule, DxTreeViewModule } from 'devextreme-angular';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { DateValidationService } from 'src/app/forms/fields/components/date-validation.service';
import { OverflowToggleDirective } from '../common/directives/overflow-toggle/overflow-toggle.directive';
import { SharedModule } from '../shared.module';
import { ViewsModule } from '../views/views.module';
import { CommentaryFormFieldComponent } from './conversation-forms/comment-form/comment-form.component';
import { MessageFormFieldComponent } from './conversation-forms/message-form/message-form.component';
import { AuthenticatorBindingFieldComponent } from './fields/components/authenticator-binding-field/authenticator-binding-field.component';
import { CheckboxSwitchFormFieldComponent } from './fields/components/checkbox-switch-form-field/checkbox-switch-form-field.component';
import { DatePickerFormFieldComponent } from './fields/components/date-picker-form-field/date-picker-form-field.component';
import { DropdownListPaginationComponent } from './fields/components/dropdown-list-pagination/dropdown-list-pagination';
import { DocumentFormFieldComponent } from './fields/components/files/document-form-field/document-form-field.component';
import { FileFormFieldComponent } from './fields/components/files/file-form-field/file-form-field.component';
import { PhotoFormFieldComponent } from './fields/components/files/photo-form-field/photo-form-field.component';
import { InputFormFieldComponent } from './fields/components/input-form-field/input-form-field.component';
import { LabelFormFieldComponent } from './fields/components/label-form-field/label-form-field.component';
import { ExtendLocationFormFieldComponent } from './fields/components/location-form-field/extend-location-form-field.component';
import { LocationFormFieldComponent } from './fields/components/location-form-field/location-form-field.component';
import { StringLocationFormFieldComponent } from './fields/components/location-form-field/string-location-form-field.component';
import { MultipleComplexSearchFormFieldComponent } from './fields/components/multiple-complex-search-form-field/multiple-complex-search-form-field.component';
import { MultipleCustomFormFieldComponent } from './fields/components/multiple-custom-names-form-field/multiple-custom-form-field.component';
import { MultipleSearchFormFieldComponent } from './fields/components/multiple-search-form-field/multiple-search-form-field.component';
import {
  CharityFocusesSelectTreeComponent,
  DiseasesSelectTreeComponent,
  SpecialtiesSelectTreeComponent,
} from './fields/components/multiple-search-form-tree/multiple-search-form-tree.component';
import { MultipleSearchMapFormFieldComponent } from './fields/components/multiple-search-map-form-field/multiple-search-map-form-field.component';
import { PhoneFormFieldComponent } from './fields/components/phone-form-field/phone-form-field.component';
import { RichEditorFieldComponent } from './fields/components/rich-editor-field/rich-editor-field.component';
import { SelectFormFieldComponent } from './fields/components/select-form-field/select-form-field.component';
import { SingleDropdownFormFieldComponent } from './fields/components/single-dropdown-form-field/single-dropdown-form-field.component';
import { TextareaFormFieldComponent } from './fields/components/textarea-form-field/textarea-form-field.component';
import { TextareaPlaceholderDirective } from './fields/components/textarea-form-field/textarea-placeholder.directive';
import { ViewportFormFieldComponent } from './fields/components/viewport-form-field/viewport-form-field.component';
import { AllowedFormFieldsService } from './fields/directive/allowed-form-fields.service';
import { FieldConstructorDirective } from './fields/directive/field-constructor.directive';
import { FieldAttributeConstructorService } from './fields/field-attributes-constructor.service';
import { CounterComponent } from './fields/shared/counter/counter.component';
import { FormConstructorBaseComponent } from './form-constructors/form-constructor-base/form-constructor-base.component';
import { FormConstructorProfileBaseComponent } from './form-constructors/form-constructor-profile-base/form-constructor-profile-base.component';
import { FormConstructorComponent } from './form-constructors/form-constructor/form-constructor.component';
import { FormStateService } from './form-state.service';
import { FormValidationService } from './form-validation.service';
import { FormsAttributeService } from './forms-attribute.service';

@NgModule({
  imports: [
    SharedModule,
    NgbDatepickerModule,
    AngularEditorModule,
    InfiniteScrollModule,
    ViewsModule,
    DxDropDownBoxModule,
    DxTreeViewModule,
    DxTextBoxModule,
  ],
  declarations: [
    FieldConstructorDirective,
    DatePickerFormFieldComponent,
    PhotoFormFieldComponent,
    InputFormFieldComponent,
    LabelFormFieldComponent,
    SelectFormFieldComponent,
    DocumentFormFieldComponent,
    MultipleSearchFormFieldComponent,
    MultipleSearchMapFormFieldComponent,
    MultipleComplexSearchFormFieldComponent,
    TextareaFormFieldComponent,
    CheckboxSwitchFormFieldComponent,
    PhoneFormFieldComponent,
    AuthenticatorBindingFieldComponent,
    FormConstructorProfileBaseComponent,
    FormConstructorComponent,
    FormConstructorBaseComponent,
    SingleDropdownFormFieldComponent,
    FileFormFieldComponent,
    ViewportFormFieldComponent,
    LocationFormFieldComponent,
    StringLocationFormFieldComponent,
    ExtendLocationFormFieldComponent,
    RichEditorFieldComponent,
    OverflowToggleDirective,
    MessageFormFieldComponent,
    CommentaryFormFieldComponent,
    MultipleCustomFormFieldComponent,
    DropdownListPaginationComponent,
    CounterComponent,
    TextareaPlaceholderDirective,
    DiseasesSelectTreeComponent,
    SpecialtiesSelectTreeComponent,
    CharityFocusesSelectTreeComponent,
  ],
  exports: [
    FormConstructorProfileBaseComponent,
    FormConstructorBaseComponent,
    FormConstructorComponent,
    SelectFormFieldComponent,
    MessageFormFieldComponent,
    CommentaryFormFieldComponent,
    CounterComponent,
  ],
})
export class FormsConstructorModule {
  public static forRoot(): ModuleWithProviders<FormsConstructorModule> {
    return {
      ngModule: FormsConstructorModule,
      providers: [
        FieldAttributeConstructorService,
        FormsAttributeService,
        AllowedFormFieldsService,
        FormValidationService,
        FormStateService,
        DateValidationService,
      ],
    };
  }
}
